import {TableDataRequest} from '@fl/cmsch-fe-library';

/**
 * Checks whether a table request action should be treated as a data-source change.
 *
 * @param tdr Table request emitted by the connected table.
 * @returns `true` when the request action is `set` or `reset`.
 */
export const potentiallyChangeOfTableDataSource = <TableRow>(tdr: TableDataRequest<TableRow>): boolean =>
    ['set', 'reset'].includes(tdr.action);
